import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';
import CardTypeEnum from '@models/enums/CardTypeEnum';
import { ILink } from '@models/ILink';
import { IProductCard } from '@models/IProductCard';
import AddToWishlist from '@molecules/AddToWishlist/AddToWishlist';
import ProductCardImage from '@molecules/ProductCardImage/ProductCardImage';

export interface IListingProductBar {
  readonly productCard: IProductCard;
  readonly cta: ILink;
  readonly subTitle: string;
}

const ListingProductBar = ({
  productCard,
  cta,
  subTitle,
}: IListingProductBar) => {
  const { category, productImage, productName, wishlistDrawerLabels } =
    productCard;

  return (
    <div className="tw-relative tw-flex tw-flex-col">
      <div className="gap-x-xs tw-mb-4 tw-flex tw-justify-between">
        <div className="tw-flex-[2]">
          <Text variant="heading-21-light" className="tw-hidden lg:tw-block">
            {subTitle}
          </Text>
          <Text variant="body-18" className="tw-font-light lg:tw-hidden">
            {subTitle}
          </Text>
        </div>
        <Button
          as="link"
          variant="link"
          href={cta.url}
          target={cta.target}
          label={cta.text}
          buttonClasses="!tw-p-0 tw-flex-1 md:tw-hidden"
          contentClasses="max-md:!tw-justify-end"
        />
      </div>
      <div className="tw-flex tw-min-h-24 tw-w-full tw-justify-between tw-bg-white tw-text-black md:tw-min-h-[140px] lg:tw-min-h-[225px]">
        {productImage && (
          <div className="tw-min-w-20 md:tw-w-32 lg:tw-w-[192px] xl:tw-w-[224px]">
            <ProductCardImage productImage={productImage.mobile} />
          </div>
        )}
        <div className="tw-my-xs tw-ml-4 tw-mr-auto tw-flex tw-flex-col tw-gap-xxs md:tw-my-xs lg:tw-my-sm lg:tw-ml-8">
          <Text variant="body-small" className="tw-uppercase tw-text-grey-70">
            {category}
          </Text>

          {productName && <Text variant="ds-headline-4">{productName}</Text>}
        </div>
        <div className="tw-relative tw-flex tw-flex-col tw-items-end tw-justify-between tw-py-xs tw-pl-xxs tw-pr-xs md:tw-min-w-fit lg:tw-py-sm lg:tw-pr-md">
          <AddToWishlist
            isCard={false}
            card={productCard}
            cardId={`${cta.url}.html`} // To match existing format
            collection={CardTypeEnum.Products}
            wishlistDrawerLabels={wishlistDrawerLabels}
            buttonVariant="grey30"
          />
          <Button
            as="link"
            variant="link"
            href={cta.url}
            target={cta.target}
            label={cta.text}
            buttonClasses="!tw-p-0 tw-hidden md:tw-block"
          />
        </div>
      </div>
    </div>
  );
};

export default ListingProductBar;
